import _taggedTemplateLiteral from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  stroke: currentColor;\n  fill: currentColor;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
export var SVG = styled.svg(_templateObject());